import React from 'react';
import styled, { css } from 'styled-components';

const PlusButton = styled.button`
  display: flex;
  align-items: center;
  outline: none;
  background-color: transparent;
  -webkit-tap-highlight-color: transparent;
  border: none;
  cursor: pointer;
`;

const Content = styled.p`
  color: #10587f;
    font-size: 14px;
    font-weight: bold;
    margin-bottom: 0;
    display: flex;
    align-items: center;
`;

const AddButton = (props) => {
  return (
    <PlusButton onClick={props.onClick}>
      <Content>
        <img className="plus" src="/img/profile/plus.svg" alt="agregar forma de pago" />
        Agregar una forma de pago
      </Content>
    </PlusButton>
  );
};

export default AddButton;
